const prefixSystemUser = 'system.user';

export default [
  {
    path: '/system/user/changePassword',
    name: `${prefixSystemUser}.changePassword`,
    hidden: false,
    component: () => import('@/views/system/user/ChangePassword.vue'),
    // component: () => import('@/views/system/user/ChangePasswordNew.vue'),
    meta: {
      title: '修改密码',
    },
  },
];
